import React from 'react';
import ErrorMessages from './ErrorMessages';
import * as styles from './CalculatorMessages.module.scss';
import classNames from 'classnames';
import { isString } from 'lodash';
import { DEFAULT_ERROR_MESSAGE } from '@constants';

export default React.memo(function CalculatorMessages({
  errors,
  className,
  noProductsSelected,
  noRatesFound,
  fetchRackRateGroups,
  showRackRatesInvitation = true,
  messageTitle,
  messageText
}) {
  // We only display errors here if they
  // are not related to input validations
  let errorMessages = null;

  if (errors) {
    if (isString(errors)) {
      errors = { general: errors };
    }

    errorMessages = Object.keys(errors)
      .filter(key => key !== 'validation')
      .map((key, index) => {
        let error = errors[key] ?? DEFAULT_ERROR_MESSAGE;

        if (isString(error) && error.includes('JSON at')) {
          error = DEFAULT_ERROR_MESSAGE;
        }

        return <p key={index}>{error}</p>;
      });
  }

  // If there are any error messages, we
  // only display those and hide any
  // additional calculator messages
  if (errorMessages?.length) {
    return (
      <ErrorMessages
        messages={errorMessages}
        showRackRatesInvitation={showRackRatesInvitation}
        fetchRackRateGroups={fetchRackRateGroups}
      />
    );
  }

  // If there are no errors, we check if
  // any additional messages should be displayed
  let messageData = null;

  if (messageText) {
    messageData = {
      title: messageTitle,
      text: messageText
    };
  } else if (noProductsSelected) {
    messageData = messages.noProductsSelected;
  } else if (noRatesFound) {
    messageData = messages.noRatesFound;
  }

  return (
    messageData && (
      <div className={classNames('content-wrapper', styles.wrapper, className)}>
        <div className={styles.content}>
          {messageData.title && (
            <h3 className={styles.title}>{messageData.title}</h3>
          )}
          {messageData.text && (
            <div className={styles.text}>
              {messageData.text.split('\n').map((t, index) => (
                <p key={index}>{t}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  );
});

// TODO make these configurable in Kentico
const messages = {
  noProductsSelected: {
    title: 'No product types selected',
    text: 'Select one or more products to view your personalized rates'
  },
  noRatesFound: {
    title: 'No eligible rates found',
    text: 'Please try adjusting your loan details'
  }
};
